import { api } from '@/api/client';
import type { DashboardStats, Health, Version } from '@/api/types';

/**
 * Mission Control system & dashboard endpoints. These are read-only and
 * are safe to hit on a short poll cadence (10–30s).
 */
export const systemApi = {
  /** GET /api/system/health — overall + component status. */
  health: () => api.get<Health>('/api/system/health'),

  /** GET /api/system/version — panel version/build metadata. */
  version: () => api.get<Version>('/api/system/version'),

  /** GET /api/system/stats — dashboard stat cards (§4.3). */
  stats: () => api.get<DashboardStats>('/api/system/stats'),
};
